import { FieldLocator } from '@app/common/configurable-wizards';
import {
  ComboboxFieldComponent,
} from '@app/common/configurable-wizards/fields/SingleChoice/Combobox/ComboboxFieldComponent';
import { isSingleChoiceField } from '@app/common/configurable-wizards/utils';

export const StatesFieldLocator: FieldLocator = (context) => (
  isSingleChoiceField(context.field) && context.field.id === 'State'
    ? ComboboxFieldComponent
    : undefined
);

export const MilitaryMailingCitiesLocator: FieldLocator = (context) => (
  isSingleChoiceField(context.field) && context.field.id === 'MilitaryMailingCities'
    ? ComboboxFieldComponent
    : undefined
);
